import React from 'react'
import { DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

class DateRangeSelectorExtended extends React.Component {
  constructor(props) {
    super(props);
    // this.handleClick = this.handleClick.bind(this);
    this.state = {
      // startDate: moment().subtract(2, 'year'),
      // endDate: moment(),
      // focusedInput: 'startDate'

    }
    if (props.startDate) this.state.startDate = moment( props.startDate  ) 
    if (props.endDate) this.state.endDate = moment( props.endDate )  

    this.handleDatesChange = this.handleDatesChange.bind(this);
    
  }
  handleClick = (me, count, period) => {
    var to = moment();
    var from = null;
    if (period === 'YTD') {
      from = moment().startOf('year');
    }
    else if(period === 'ALL'){
      from = null
    }
    else {
      from = moment().subtract(count, period)
    }
    
    // console.log(" startDate: ", from, " endDate: ", to )
    this.setState({ startDate: from, endDate: to})
    window[this.props.callback](from == null ? null: from.format('L'), to.format('L'));


  }
  onChange = (dates) => {
    const [from, to] = dates

    this.setState({ startDate: dates[0], endDate: dates[1] })
    window[this.props.callback](from == null ? null : from.format('L'), to.format('L'));


  }


  handleDatesChange(startDate, endDate){
    if (startDate !== null && endDate !== null)
    {
    this.setState({ startDate, endDate })
    }
  }
  render() {
    
    return (
      <div className='date-range-selector-container full-width'>
      <div className='date-range-selector '>
        <label>Zoom</label>
        <span className="badge" onClick={(e) => this.handleClick(e, 7, 'day')}>1W</span>
        <span className="badge" onClick={(e) => this.handleClick(e, 14, 'day')}>2W</span>
        <span className="badge" onClick={(e) => this.handleClick(e, 1, 'month')}>1M</span>
        <span className="badge" onClick={(e) => this.handleClick(e, 2, 'month')}>2M</span>
        <span className="badge" onClick={(e) => this.handleClick(e, 3, 'month')}>3M</span>
        <span className="badge" onClick={(e) => this.handleClick(e, 6, 'month')}>6M</span>
        <span className="badge" onClick={(e) => this.handleClick(e, 0, 'YTD')}>YTD</span>
        <span className="badge" onClick={(e) => this.handleClick(e, 1, 'year')}>1Y</span>
        <span className="badge" onClick={(e) => this.handleClick(e, 0, 'ALL')}>All</span>
      </div>
      <div className='' style={{marginBottom: "10px", marginTop: '15px'}}>
      {/* <DateRangePicker
        startDate={this.state.startDate} // momentPropTypes.momentObj or null,
        startDateId={this.props.startDateInputId} // PropTypes.string.isRequired,
        endDate={this.state.endDate} // momentPropTypes.momentObj or null,
        endDateId={this.props.endDateInputId} // PropTypes.string.isRequired,
        onDatesChange={({ startDate, endDate }) => { this.setState({ startDate, endDate }); window[this.props.callback](moment(startDate).format('L'), moment(endDate).format('L'));} } // PropTypes.func.isRequired,
        isOutsideRange={() => false}
        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
        onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
        minimumNights={0}
      /> */}
          <RangePicker
            value={[this.state.startDate, this.state.endDate]}
            onChange = {this.onChange}
          />

        </div>
      </div>

    )

  }
  
}

// DateRangeSelector.defaultProps = {
//   startDateInputId: 'start-date-field',
//   endDateInputId: 'end-date-field',
// }

export default DateRangeSelectorExtended

